module.exports = __webpack_public_path__ + "media/assets/images/blog/glossario_datalake-small-5147c5570289a20a2773c65d4101b859.png";